// extracted by mini-css-extract-plugin
export var fullGrid = "_24-3";
export var pdpPreviewContainer = "_24-1";
export var previewContainer = "_24-0";
export var togglePreviewContainer = "_24-2";